import { Injectable, effect, inject } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs';
import { I18nService } from './i18n.service';
import { TranslationKey } from './i18n.translations';

@Injectable({
  providedIn: 'root',
})
export class RouteTitleService {
  private readonly router = inject(Router);
  private readonly title = inject(Title);
  private readonly i18n = inject(I18nService);

  constructor() {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => this.updateTitle());

    effect(() => {
      this.i18n.locale();
      this.updateTitle();
    });

    this.updateTitle();
  }

  private updateTitle(): void {
    const titleKey = this.findTitleKey(this.router.routerState.snapshot.root);
    if (!titleKey) {
      this.title.setTitle(this.i18n.t('app.meta.title'));
      return;
    }

    const routeTitle = this.i18n.t(titleKey);
    const appName = this.i18n.t('app.name');
    this.title.setTitle(routeTitle === appName ? appName : `${routeTitle} | ${appName}`);
  }

  private findTitleKey(route: ActivatedRouteSnapshot): TranslationKey | null {
    let current: ActivatedRouteSnapshot | null = route;
    let titleKey: TranslationKey | null = null;

    while (current) {
      const routeKey = current.data['titleKey'];
      if (typeof routeKey === 'string') {
        titleKey = routeKey as TranslationKey;
      }
      current = current.firstChild ?? null;
    }

    return titleKey;
  }
}
